import printPackedOrdersComponent from './print_packed_orders.component';
import './print_packed_orders.scss';

let printPackedOrdersModule = angular.module('printPackedOrders', [
])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/order-packing');

		$stateProvider
			.state('printPackedOrders', {
				url: '/print-packed-orders',
				component: 'printPackedOrders',
				data: {
					requireLogin: true,
					requireACL: 'order_packing.all'
				},
			});
	})

	.component('printPackedOrders', printPackedOrdersComponent)

	.name;

export default printPackedOrdersModule;




// WEBPACK FOOTER //
// ./client/app/components/order_packing/print_packed_orders/index.js